import { GetInitialVisitAdjusterEntryTabsQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialvisitAdjusterEntryTabs/getInitialvisitAdjusterEntryTabsQuery.type';
import { getInitialVisitAdjusterEntryTabsFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialvisitAdjusterEntryTabs/getInitialvisitAdjusterEntryTabsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getInitialVisitAdjusterEntryTabsQueryOptions = (
  params: GetInitialVisitAdjusterEntryTabsQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['GetInitialVisitAdjusterEntryTabsQuery', params],
    queryFn: () => getInitialVisitAdjusterEntryTabsFunction(params),
  });
};
